module.exports = __webpack_public_path__ + "img/about_member_hiroki.fc064606.png";